import React from 'react';
import styles from './ZombiePurgeList.module.scss';
import { ActionButton } from 'src/ui/components';
import ZombiePurgeCheckbox from '../Checkbox';

export default function ZombiePurgeListHeader({ selectedZombiesLength, emptyList, onSelectAll, zombiesLength, isAllSelected, onPurgeClick, disablePurgeButton, setOtherAddress, isValidAddress, mintToAnotherAddress, setMintToAnotherAddress, otherAddress, isOtherAddressSimilarToConnectedAddress }) {

	const SimilarAddress = () => {
		return <span className=' text-lg text-bold text-[red]'>identical to connected address</span>;
	};
	const ValidAddress = () => {
		return <span
			className='text-lg text-bold text-[#B3FE00]'>
			Valid Address
		</span>;
	};
	const InvalidAddress = () => {
		return <span className=' text-lg text-bold text-[red]'>Invalid Address</span>;
	};

	const AddressAlert = () => {
		if ( isOtherAddressSimilarToConnectedAddress ) {
			return <SimilarAddress />;
		}
		else if ( isValidAddress ) {
			return <ValidAddress />;
		}
		else {
			return <InvalidAddress />;
		}
	};

	return (
		<div id="zombie-purge-header"
			className="max-[1000px]:pb-6 flex flex-col items-center">
			<div className="text-center">
				<h2>Select Zombies to Purge</h2>
				<p className="max-w-xl">
					You’ll be rewarded with one “The End of the War”, for each Zombie that you Purge, which will be usable for the Apepe Rebirth.
				</p>
			</div>
			<div className="max-[1000px]:flex-col relative flex items-center w-full">
				<p
					className={`text-center box-border  flex-grow pt-4 pb-4 pl-3 pr-3 text-sm m-0 mr-6 rounded-[12px]  ${styles['zombie-purge-list-balance-bar']}`}
				>
					You will receive
					<span
						className={`-f-family-burbank  font-bold  mr-1 ml-1 text-[30px] leading-[140%] max-[1100px]:text-[25px] max-[768px]:text-[40px] ${styles['zombie-purge-list-balance-bar-number']}`}
					>
						{selectedZombiesLength}
					</span>
					'The End of the War' as a reward for this sacrifice!
					{isValidAddress && `And they will be sent to this address: ${otherAddress}`}
				</p>
				{!emptyList ? <ActionButton
					onClick={onPurgeClick}
					disabled={disablePurgeButton}
					className='text-3xl h-16 w-40 max-[1000px]:w-full'
					textContent="purge!!!"
				/> : <div className={`font-bold text-xl text-center w-44 pt-4 pb-4 pl-3 pr-3 -f-family-burbank max-[1000px]:w-full ${styles['zombie-purge-list-purge-empty']}`}> SORRY, NO ZOMBIES</div>}
			</div>
			{mintToAnotherAddress && <div
				className='relative w-full flex items-center justify-between mt-4'>
				<div className='w-[70%]'>
					<label htmlFor="other_address"
						className="mb-2 text-sm font-medium text-white w-1/4 ">
						Other Address
					</label>
					<input type="text"
						id="other_address"
						className="relative w-full bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
						placeholder="0x"
						required
						onChange={( e ) => setOtherAddress( e.target.value )}
					/>
				</div>
				<div className='mt-6'
				>
					<AddressAlert />
				</div>

			</div>}
			<div className={`flex justify-between items-center w-full h-auto mt-8 ${styles['zombie-purge-list-control-bar']}`}>
				<button
					className={`mr-0 p-0 flex items-center ${styles['zombie-purge-list-control-bar-checkbox']}`}>
					<ZombiePurgeCheckbox
						isSelected={isAllSelected}
						onClick={onSelectAll} />
					<span>Select all</span>
				</button>

				<button
					className={`mr-0 p-0 flex items-center ${styles['zombie-purge-list-control-bar-checkbox']}`}>
					<ZombiePurgeCheckbox
						isSelected={mintToAnotherAddress}
						onClick={() => setMintToAnotherAddress( ( prev ) => !prev )} />
					<span>Mint to Another Address</span>
				</button>
				<div className='text-[#B3FE00] max-[768px]:mt-[1%]'>
					<span className="ml-0.5 mr-0.5 font-normal text-lg leading-none">{selectedZombiesLength}</span>
					<span className="ml-0.5 mr-0.5 font-normal text-lg leading-none">of</span>
					<span className="ml-0.5 mr-0.5 font-normal text-lg leading-none">{zombiesLength}</span>
					<span className="ml-0.5 mr-0.5 font-normal text-lg leading-none">selected</span>
				</div>
			</div>

			<div className={`w-full bg-white mt-8 mb-8 opacity-20 h-px ${styles['zombie-purge-list-control-bar-divider']}`} />
		</div>
	);
}
